export class Resource {
  success?: boolean;
  id?: number;
  // tslint:disable-next-line: variable-name
  client_id?: number;
  data?: any;
  status? :any
}
